import React, {useEffect, useState} from "react";
import {JSON_HEADERS, COMPANY_NAME} from "../../constants/constants";
import Modal from 'react-bootstrap/Modal';
import ResponseModal from "../modals/ResponseModal";
import {useForm} from "react-hook-form";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

export default function ReportContent({item, itemType, itemUrl, userSignedIn, token, linkClasses, toggleRegistration, leadData={}}) {

    const [showReportContentModal, setShowReportContentModal] = useState(false);
    const [showResponseModal, setShowResponseModal] = useState(false);
    const [btnCta, setBtnCta] = useState('Submit');
    const { register, handleSubmit, clearErrors, reset, formState: { errors, isSubmitting }} = useForm();

    // event handlers

    const onShowReportContentModal = (show) => {
        setShowReportContentModal(show);
    }

    const onHandleReportContent = async(data) => {
        setBtnCta('Sending...');
        await fetch('/admin_messages/inappropriate', {
            method: 'POST',
            headers: JSON_HEADERS,
            body: JSON.stringify(data)
        });

        onHandleReportClose();
        setShowResponseModal(true);
    }

    const onHandleReportClose = () => {
        reset();
        clearErrors('reason');
        setBtnCta('Submit');
        setShowReportContentModal(false);
    }

    const onHandleResponseModal = (show) => {
        setShowResponseModal(show)
    }

    // Render methods

    const renderReasonForm = () => {
        return (
            <Form
                noValidate={true}
                acceptCharset='UTF-8'
                onSubmit={handleSubmit(onHandleReportContent)}
            >
                <input type='hidden' id='authenticity_token' key='authenticity_token' value={token} {...register('authenticity_token')} />
                <input type='hidden' id='item_id' key='item_id' value={item.id} {...register('item_id')} />
                <input type='hidden' id='item_type' key='item_type' value={itemType} {...register('item_type')} />

                <Form.Group className="my-3 text-start">
                    <Form.Control
                        as={'textarea'}
                        rows={3}
                        id='reason'
                        placeholder='Type your comment here'
                        {...register("reason", { required: 'This field is required' })} />
                    {errors.reason && <Form.Text className="text-danger">{errors.reason.message}</Form.Text>}
                </Form.Group>

                <div className={'d-flex justify-content-end mt-4'}>
                    <Button variant="light" className={'me-2'} onClick={() => onHandleReportClose()}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit" className={'btn-hover-cursor'} disabled={isSubmitting}>
                        {btnCta}
                    </Button>
                </div>
            </Form>
        )
    }

    const renderReportContentModal = () => {
        return (
            <Modal show={showReportContentModal}>
                <Modal.Body className={'p-3'}>
                    <h4>Report Content</h4>
                    <div className={'mt-3'}>Please explain why you feel this item should be removed from {COMPANY_NAME}.</div>
                    {renderReasonForm()}
                </Modal.Body>
            </Modal>
        )
    }

    const renderResponseModal = () => {
        if(showResponseModal) {
            return (
                <ResponseModal
                    modalSize={'md'}
                    bgColor={'white'}
                    textColor={'secondary'}
                    btnColor={'primary'}
                    icon={'check-circle'}
                    header={'Thank you'}
                    message={'We have received your feedback - thank you for letting us know.<br>Our editorial team will check your request.'}
                    show={showResponseModal}
                    handleShow={onHandleResponseModal} />
           )
        }
    }

    return (
        <>
            <a
                onClick={() => userSignedIn ? onShowReportContentModal(true) : toggleRegistration(leadData)}
                data-after-signin-redirect={itemUrl}
                data-external-only={1}
                className={`${linkClasses}`}
            >
                <i className={'fal fa-bullhorn me-2'}></i>
                Report as inappropriate
            </a>
            {renderReportContentModal()}
            {renderResponseModal()}
        </>
    )

}